import { User, UserRole } from '@/interfaces/userInfo';
import Vue from 'vue';
import { Commit, Dispatch } from 'vuex';
import { Role } from '@/interfaces/types';
import { AxiosResponse } from 'axios';

interface UserState {
	user: User | null;
	userRole: Role | null;
}

export default {
	namespaced: true,
	state: {
		user: null,
		userRole: null,
	} as UserState,
	getters: {
		getUser: (state: UserState): User | null => {
			return state.user;
		},

		getRole: (state: UserState): Role | null => {
			return state.userRole;
		},
	},
	mutations: {
		SET_USER(state: UserState, user: User): void {
			state.user = user;
		},

		SET_USER_ROLE(state: UserState, userRole: Role): void {
			state.userRole = userRole;
		},

		RESET_USER(state: UserState): void {
			state.user = null;
		},

		RESET_USER_ROLE(state: UserState): void {
			state.userRole = null;
		},
	},
	actions: {
		async fetchUser(
			{ commit, dispatch }: { commit: Commit; dispatch: Dispatch },
			{ id }: { id: number }
		): Promise<void> {
			try {
				const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL}/users/${id}`);
				if (response && response.status === 200) {
					commit('SET_USER', response.data.data);
				}
			} catch (error) {
				if ((error as AxiosResponse).status === 401) {
					dispatch('authentication/logOut', null, { root: true });
				}
			}
		},

		setUserRole({ commit }: { commit: Commit }, { userRole }: { userRole: UserRole }): void {
			commit('SET_USER_ROLE', userRole);
		},

		cleanUser({ commit }: { commit: Commit }): void {
			commit('RESET_USER');
			commit('RESET_USER_ROLE');
		},
	},
};
